import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccd3cd12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-player-tips-root-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box__headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Dnevnik ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "box__list"
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppPlayerTipsRootListFormLookupIndexVue = _resolveComponent("AppPlayerTipsRootListFormLookupIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.tips.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tips, (tip, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: tip.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, " #" + _toDisplayString(key + 1) + " - " + _toDisplayString(tip.user.content.name) + " " + _toDisplayString(tip.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.moment(tip.created_at).format('DD.MM.YYYY.')), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AppPlayerTipsRootListFormLookupIndexVue, { tip: tip }, null, 8, ["tip"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, " Nema podataka... "))
    ])
  ]))
}